import React, { useState, useEffect } from "react";
import { json, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import { Tooltip as ReactTooltip } from "react-tooltip";

import Select from "react-select";
import Papa from "papaparse";
import {
  SearchIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  DownloadIcon,
  DetailIcon,
  EditIcon,
  CloudIcon,
} from "../../assets/Icons";
import {
  setGlobalData,
  setLocalData,
  deleteLocalData,
  setExpendRow,
  setSelectedType,
  setcsvReadedData,
  setLang,
} from "../../store/reducers/globalReducer";

import Wrapper from "../../routes/Wrapper";
import Modal from "../../components/Modal";
import Loader from "../../components/Loader";

import GlobalHeadline from "../../components/GlobalRow/GlobalHeadline";
import GlobalDescription from "../../components/GlobalRow/GlobalDescription";
import RowExpendHeadline from "../../components/DataTable/RowExpendHeadline";
import RowExpendDescription from "../../components/DataTable/RowExpendDescription";

import TableRowModel from "../../components/TableRowModel";
import UpdateHeadlineModel from "../../components/UpdateHeadlineModel";
import GenerateUrlSummaryModel from "../../components/GenerateUrlSummaryModel";

const Main = () => {
  const dispatch = useDispatch();
  const {
    globalData,
    localData,
    expendRow,
    selectedType,
    csvReadedData,
    globalSelectedHeadlines,
    lang,
  } = useSelector((state) => state.globalReducer);
  const [mod_localData, setMod_localData] = useState([]);

  const deleteData = () => {
    dispatch(deleteLocalData("localData"));
    dispatch(deleteLocalData("globalData"));
    dispatch(deleteLocalData("csvReadedData"));
    dispatch(deleteLocalData("selectedType"));
    dispatch(deleteLocalData("expendRow"));
    dispatch(deleteLocalData("formInfo"));
    window.location.reload();
  };
  const [selectedLang, setSelectedLang] = useState(lang);
  const languageList = [
    { label: "English", value: "english" },
    // { label: "German", value: "german" },
    { label: "German Formal", value: "germanF" },
    { label: "German Informal", value: "germanInF" },
  ];
  const handleLanguage = (e) => {
    setSelectedLang(e);
    dispatch(setLang(e));
  };
  const [userFile, setUserFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);

  const headers = [
    { label: "Campaign", key: "Campaign" },
    { label: "Ad Group", key: "Ad Group" },
    { label: "Ad type", key: "Ad type" },
    { label: "Labels", key: "Labels" },
    { label: "Headline 1", key: "Headline 1" },
    { label: "Headline 1 position", key: "Headline 1 position" },
    { label: "Headline 2", key: "Headline 2" },
    { label: "Headline 2 position", key: "Headline 2 position" },
    { label: "Headline 3", key: "Headline 3" },
    { label: "Headline 3 position", key: "Headline 3 position" },
    { label: "Headline 4", key: "Headline 4" },
    { label: "Headline 4 position", key: "Headline 4 position" },
    { label: "Headline 5", key: "Headline 5" },
    { label: "Headline 5 position", key: "Headline 5 position" },
    { label: "Headline 6", key: "Headline 6" },
    { label: "Headline 6 position", key: "Headline 6 position" },
    { label: "Headline 7", key: "Headline 7" },
    { label: "Headline 7 position", key: "Headline 7 position" },
    { label: "Headline 8", key: "Headline 8" },
    { label: "Headline 8 position", key: "Headline 8 position" },
    { label: "Headline 9", key: "Headline 9" },
    { label: "Headline 9 position", key: "Headline 9 position" },
    { label: "Headline 10", key: "Headline 10" },
    { label: "Headline 10 position", key: "Headline 10 position" },
    { label: "Headline 11", key: "Headline 11" },
    { label: "Headline 11 position", key: "Headline 11 position" },
    { label: "Headline 12", key: "Headline 12" },
    { label: "Headline 12 position", key: "Headline 12 position" },
    { label: "Headline 13", key: "Headline 13" },
    { label: "Headline 13 position", key: "Headline 13 position" },
    { label: "Headline 14", key: "Headline 14" },
    { label: "Headline 14 position", key: "Headline 14 position" },
    { label: "Headline 15", key: "Headline 15" },
    { label: "Headline 15 position", key: "Headline 15 position" },
    { label: "Description 1", key: "Description 1" },
    { label: "Description 1 position", key: "Description 1 position" },
    { label: "Description 2", key: "Description 2" },
    { label: "Description 2 position", key: "Description 2 position" },
    { label: "Description 3", key: "Description 3" },
    { label: "Description 3 position", key: "Description 3 position" },
    { label: "Description 4", key: "Description 4" },
    { label: "Description 4 position", key: "Description 4 position" },
    { label: "Path 1", key: "Path 1" },
    { label: "Path 2", key: "Path 2" },
    { label: "Final URL", key: "Final URL" },
    { label: "Final mobile URL", key: "Final mobile URL" },
    { label: "Campaign Status", key: "Campaign Status" },
    { label: "Ad Group Status", key: "Ad Group Status" },
    { label: "Status", key: "Status" },
    { label: "Approval Status", key: "Approval Status" },
  ];

  const csvReport = {
    data: localData,
    headers: headers,
    filename: "newAdsFile.csv",
  };

  useEffect(() => {
    if (localData?.length) {
      setUserFile(localData);
    }
  }, [localData]);

  const [selectedGlobalBox, setSelectedGlobalBox] = useState("headline");
  const [globalExpend, setGlobalExpend] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [open, setOpen] = useState(false);
  const [openGenerateUrl, setOpenGenerateUrl] = useState(false);

  const campaignList = [
    { display: "Campaign 1", value: "campaign1" },
    { display: "Campaign 2", value: "campaign2" },
    { display: "Campaign 3", value: "campaign3" },
    { display: "Campaign 4", value: "campaign4" },
    { display: "Campaign 5", value: "campaign5" },
  ];
  const adGroup = [
    { display: "AdGroup 1", value: "adGroup1" },
    { display: "AdGroup 2", value: "adGroup2" },
    { display: "AdGroup 3", value: "adGroup3" },
    { display: "AdGroup 4", value: "adGroup4" },
    { display: "AdGroup 5", value: "adGroup5" },
  ];

  const exportToCsv = (array) => {
    var CsvString = "";
    localData?.forEach(function (RowItem, RowIndex) {
      RowItem?.forEach(function (ColItem, ColIndex) {
        CsvString += ColItem + ",";
      });
      CsvString += "\r\n";
    });
    CsvString = "data:application/csv," + encodeURIComponent(CsvString);
    var x = document.createElement("A");
    x.setAttribute("href", CsvString);
    x.setAttribute("download", "somedata.csv");
    document.body.appendChild(x);
    x.click();
  };
  const [selectedHeadlineVal, setSelectedHeadlineVal] = useState();
  const [modelData, setModelData] = useState();
  const [selectedHeadlines, setselectedHeadlines] = useState({});
  const [selectedDescriptions, setselectedDescriptions] = useState({});

  const [localDataHeadingkeys, setlocalDataHeadingkeys] = useState([]);
  const [localDataDescriptionkeys, setlocalDataDescriptionkeys] = useState([]);

  const validatevalue = (val) => {
    return (
      val != " -" && val != " --" && val != "" && val != " -" && val != " "
    );
  };

  useEffect(() => {
    let headings = [];
    let descriptions = [];
    let mod_selectedHeadlines = {};
    let mode_selectedDescriptions = {};
    // console.log("csvReadedData_called");
    csvReadedData?.map((mainitem, index) => {
      Object.keys(csvReadedData[index])?.map((item) => {
        if (item?.includes("Headline") && !item?.includes("position")) {
          if (mod_selectedHeadlines[`row${index}`]) {
            if (validatevalue(csvReadedData[index][item])) {
              if (mod_selectedHeadlines[`row${index}`].length < 15) {
                mod_selectedHeadlines[`row${index}`]?.push({
                  Headline: csvReadedData[index][item],
                });
              }
            }
          } else {
            if (validatevalue(csvReadedData[index][item])) {
              mod_selectedHeadlines[`row${index}`] = [
                { Headline: csvReadedData[index][item] },
              ];
            }
          }
          headings.push(csvReadedData[index][item]);
        } else if (
          item?.includes("Description") &&
          !item?.includes("position")
        ) {
          if (mode_selectedDescriptions[`row${index}`]) {
            if (validatevalue(csvReadedData[index][item])) {
              if (mode_selectedDescriptions[`row${index}`].length < 4) {
                mode_selectedDescriptions[`row${index}`]?.push({
                  Description: csvReadedData[index][item],
                });
              }
            }
          } else {
            if (validatevalue(csvReadedData[index][item])) {
              mode_selectedDescriptions[`row${index}`] = [
                { Description: csvReadedData[index][item] },
              ];
            }
          }
          descriptions.push(csvReadedData[index][item]);
        }
      });
      // console.log("headings", headings);
      setselectedHeadlines({ ...mod_selectedHeadlines });
      setselectedDescriptions({ ...mode_selectedDescriptions });
    });
    setlocalDataHeadingkeys(headings);
    setlocalDataDescriptionkeys(descriptions);
  }, [csvReadedData]);

  const cleanDefaultKeys = (data) => {
    let the_data = [];
    data?.map((item, index) => {
      let an_array = {};
      Object.keys(data[index])?.map((item) => {
        if (!item?.includes("Headline") && !item?.includes("Description")) {
          an_array[item] = data[index]?.[item];
        }
      });
      the_data.push(an_array);
    });
    console.log("final_the_dataa", the_data);
    return the_data;
  };

  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  }

  const findpositionbykeyvalue = () => {};

  const prepare_csv_data_to_download = () => {
    let the_data = [...localData];
    the_data = cleanDefaultKeys(the_data);
    the_data?.map((item, index) => {
      if (selectedHeadlines?.[`row${index}`]) {
        selectedHeadlines?.[`row${index}`]?.map((item, indx) => {
          the_data[index] = {
            ...the_data[index],
            [`Headline ${indx + 1}`]: item?.Headline,
            [`Headline ${indx + 1} position`]:
              localData[index]?.[
                `${getKeyByValue(localData[index], item?.Headline)} position`
              ],
          };
        });
      }
      if (selectedDescriptions?.[`row${index}`]) {
        selectedDescriptions?.[`row${index}`]?.map((item, indx) => {
          the_data[index] = {
            ...the_data[index],
            [`Description ${indx + 1}`]: item?.Description,
            [`Description ${indx + 1} position`]:
              localData[index]?.[
                `${getKeyByValue(localData[index], item?.Description)} position`
              ],
          };
        });
      }
    });

    setMod_localData([...the_data]);
  };

  const TableRow = ({ item, index }) => {
    // console.log("what is tableRow item...", index, item);
    const [openUpdateHeadline, setOpenUpdateHeadline] = useState(false);

    const [selectedStyle, setSelectedStyle] = useState(null);
    const StyleList = [
      {
        display: "Choose Style 1",
        value: "style1",
      },
      {
        display: "Choose Style 2",
        value: "style2",
      },
      {
        display: "Choose Style 3",
        value: "style3",
      },
      {
        display: "Choose Style 4",
        value: "style4",
      },
      {
        display: "Choose Style 5",
        value: "style5",
      },
    ];

    // console.log("selectedHeadlines_main", selectedHeadlines);

    const countHeadlines2 = (item) => {
      let filteredHeadlines = [];
      let notEmpty;
      for (let i = 0; i < Object?.keys(item)?.length; i++) {
        filteredHeadlines.push(item[`Headline ${i}`]);
      }
      if (filteredHeadlines?.length) {
        notEmpty = filteredHeadlines?.filter((el) => {
          if (!el || el == " --") {
            return null;
          } else {
            return el;
          }
        });
      }
      return notEmpty;
    };

    const countDescription2 = (item) => {
      let filteredDescription = [];
      let notEmpty;
      for (let i = 0; i < Object?.keys(item)?.length; i++) {
        filteredDescription.push(item[`Description ${i}`]);
      }
      if (filteredDescription?.length) {
        notEmpty = filteredDescription?.filter((el) => {
          if (!el || el == " --" || el == "-- " || el == "--") {
            return null;
          } else {
            return el;
          }
        });
      }
      return notEmpty;
    };

    return (
      <>
        {item?.["Ad Group"] !== "" &&
        item?.["ad group"] !== "" &&
        item?.["Ad status"] !== "" &&
        item?.["Campaign"] !== "" ? (
          <div
            key={index}
            className={`main-table-row flex flex-col ${
              expendRow.status && expendRow.index === index ? "expend" : ""
            } `}
          >
            <div className={`tbl-row flex items-center cursor-pointer `}>
              <div className="row-item flex items-start justify-center flex-col">
                {item?.["Campaign"] ? (
                  <div className="flex items-center">
                    <h1 className="tag text-black">{item?.["Campaign"]}</h1>
                  </div>
                ) : null}
                {item?.["campaign"] ? (
                  <div className="flex items-center">
                    <h1 className="tag  text-black">{item?.["campaign"]}</h1>
                  </div>
                ) : null}
              </div>
              <div className="row-item flex items-start justify-center flex-col">
                {item?.["Ad Group"] ? (
                  <div className="flex items-center">
                    <h1 className="tag  text-black">{item?.["Ad Group"]}</h1>
                  </div>
                ) : null}
                {item?.["Ad group"] ? (
                  <div className="flex items-center">
                    <h1 className="tag  text-black">{item?.["Ad group"]}</h1>
                  </div>
                ) : null}
                {item?.["ad group"] ? (
                  <div className="flex items-center">
                    <h1 className="tag  text-black">{item?.["ad group"]}</h1>
                  </div>
                ) : null}
              </div>
              <div className="row-item flex flex-col items-start">
                <div className="item flex items-center">
                  <button
                    onClick={(e) => {
                      dispatch(
                        setSelectedType({
                          lbl: "headline",
                          index: index,
                        })
                      );
                    }}
                    className={`cleanbtn radio-btn rel ${
                      (selectedType.lbl === "headline") &
                      (selectedType.index === index)
                        ? "on"
                        : ""
                    }`}
                  />
                  <div className="toggle-desc ml-2">
                    <div className="mr-2">{countHeadlines2(item)?.length}</div>
                    {countHeadlines2(item)?.length > 1
                      ? "Headlines"
                      : "Headline"}
                  </div>
                </div>
                <div className="item flex items-center">
                  <button
                    onClick={(e) => {
                      dispatch(
                        setSelectedType({
                          lbl: "description",
                          index: index,
                        })
                      );
                    }}
                    className={`cleanbtn radio-btn rel ${
                      selectedType.lbl === "description" &&
                      selectedType.index === index
                        ? "on"
                        : ""
                    }`}
                  />
                  <div className="toggle-desc ml-2">
                    <div className="mr-2">
                      {countDescription2(item)?.length}
                    </div>
                    {countDescription2(item)?.length > 1
                      ? "Descriptions"
                      : "Description"}
                  </div>
                </div>
              </div>
              <div className="row-item flex items-center justify-end">
                <div className="icons-actions flex items-center">
                  <div
                    id="website-icon"
                    className="cloud-icon icon flex items-center justify-center relative"
                    onClick={(e) => {
                      setOpenGenerateUrl(true);
                      setModelData({ item, index });
                    }}
                  >
                    <CloudIcon />
                  </div>
                  <div
                    id="detail-icon"
                    className="detail-icon icon flex items-center justify-center"
                    onClick={(e) => {
                      setOpen(true);
                      setModelData({ item, index });
                    }}
                  >
                    <DetailIcon />
                  </div>
                  <div
                    id="expend-icon"
                    className="arrow-icon icon flex items-center justify-center"
                    onClick={(e) => {
                      if (
                        expendRow?.status === true &&
                        expendRow?.index === index
                      ) {
                        dispatch(
                          setExpendRow({
                            status: false,
                            index: "",
                          })
                        );
                      } else {
                        dispatch(
                          setExpendRow({
                            status: true,
                            index: index,
                          })
                        );
                        dispatch(
                          setSelectedType({
                            lbl: "headline",
                            index: index,
                          })
                        );
                      }
                    }}
                  >
                    {expendRow.status && expendRow.index === index ? (
                      <ArrowUpIcon />
                    ) : (
                      <ArrowDownIcon />
                    )}
                  </div>
                </div>
              </div>
              <ReactTooltip
                anchorId="website-icon"
                place="top"
                type="info"
                variant="info"
                effect="float"
                content="Generate Description from Website"
              />
              <ReactTooltip
                anchorId="detail-icon"
                place="top"
                type="info"
                variant="info"
                effect="float"
                content="See More Detail"
              />
              <ReactTooltip
                anchorId="expend-icon"
                place="top"
                type="info"
                variant="info"
                effect="float"
                content="Expand"
              />
            </div>
            {expendRow.status && expendRow.index === index && (
              <>
                {(selectedType.lbl === "headline") &
                (selectedType.index == index) ? (
                  <>
                    {countHeadlines2(item)?.length ? (
                      <RowExpendHeadline
                        item={item}
                        index={index}
                        setExpendRow={setExpendRow}
                        setselectedHeadlines={setselectedHeadlines}
                        selectedHeadlines={selectedHeadlines}
                        localDataHeadingkeys={localDataHeadingkeys}
                        globalSelectedHeadlines={globalSelectedHeadlines}
                      />
                    ) : null}
                  </>
                ) : (selectedType.lbl === "description") &
                  (selectedType.index == index) ? (
                  <>
                    {countDescription2(item)?.length ? (
                      <RowExpendDescription
                        item={item}
                        index={index}
                        setExpendRow={setExpendRow}
                        setselectedDescriptions={setselectedDescriptions}
                        selectedDescriptions={selectedDescriptions}
                        localDataDescriptionkeys={localDataDescriptionkeys}
                      />
                    ) : null}
                  </>
                ) : null}
              </>
            )}
          </div>
        ) : null}
        <Modal
          open={openUpdateHeadline}
          onClose={() => setOpenUpdateHeadline(false)}
        >
          <UpdateHeadlineModel
            setOpen={setOpenUpdateHeadline}
            selectedHeadlineVal={selectedHeadlineVal}
            setSelectedHeadlineVal={setSelectedHeadlineVal}
          />
        </Modal>
      </>
    );
  };

  const UploadFile = () => {
    if (uploadedFile) {
      Papa.parse(uploadedFile[0], {
        header: true,
        complete: function (results) {
          dispatch(setLocalData(results.data));
          dispatch(setcsvReadedData(results.data));
        },
      });
    }
  };

  const DemoFile = () => {
    const link = document.createElement("a");
    link.href = DemoFile;
    link.download = "Demo.csv";
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  return (
    <Wrapper>
      <div className="lading-page bg-themeColor2 h-screen flex">
        <div className="wrap wrapWidth flex flex-col">
          <div className="page-title flex items-center justify-center">
            <div className="page-title-tag">
              Google Ads Headline and Description Generator
            </div>
          </div>
          <div className="page-header flex items-center">
            <div className="row flex flex-col">
              <div className="tag">Add CSV File*</div>
              <div className="text-sm">
                Please upload an existing CSV file containing Campaign, Ad-group
                ,URL, Headline and Description information.
                <br /> You can use an editor or Google Ads download file <br />
                Please remove summary rows such as totals.
              </div>
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                className="select-file"
                onChange={(e) => {
                  const files = e.target.files;
                  setUploadedFile(files);
                  setUserFile(files[0]);
                }}
              />
              <div className="file-action flex items-center">
                <button
                  className="btn button mr-5"
                  onClick={(e) => {
                    UploadFile();
                  }}
                >
                  Upload Data
                </button>
                <button
                  className="btn button"
                  onClick={(e) => {
                    deleteData();
                  }}
                >
                  Clear Data
                </button>
                <Select
                  defaultValue={selectedLang}
                  value={selectedLang}
                  onChange={handleLanguage}
                  options={languageList}
                  className="select w-full"
                  name="language"
                  placeholder="Choose Language"
                />
              </div>
              {/* <div className="note-sec flex flex-col mt-4">
                <div className="tag">NOTE: </div>
                <div className="flex items-center mt-5">
                  <button
                    className="btn-download button mr-2 w-full"
                    onClick={(e) => {
                      DemoFile();
                    }}
                  >
                    <DownloadIcon />
                  </button>
                  <div className="text-sm">
                    “Upload this blank template to get started, if you don’t
                    have a pre-existing editor export file”
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className="page_block flex flex-col">
            <div className="block_filter flex items-center">
              {/* <div className="field flex flex-col">
                <div className="f-lbl">Search Ad-Group</div>
                <div className=" txt search-box flex items">
                  <div className="icon flex items-center justify-center">
                    <SearchIcon />
                  </div>
                  <input
                    type="text"
                    className="txt-s"
                    placeholder="Search Ad Group"
                  />
                </div>
              </div> */}
              {/* <div className="field flex flex-col">
                <div className="f-lbl">Campaign</div>
                <Select
                  defaultValue={selectedCampaign}
                  value={selectedCampaign}
                  onChange={setSelectedCampaign}
                  getOptionLabel={(option) => option.display}
                  getOptionValue={(option) => option.value}
                  options={campaignList}
                  className="select"
                  id="campaign"
                  name="campaign"
                  placeholder="Select Campaign"
                />
              </div> */}
              {/* <div className="field flex flex-col h-full justify-end">
                <div className="action flex items-center justify-center">
                  <button className="btn button">Select</button>
                </div>
              </div> */}
            </div>
            <div className="table-section flex flex-col">
              <div className="tbl-sec-hdr flex items-center justify-between">
                {/* <div className="table-name">Ad Elements by Ad Group</div> */}
                <div className="block-tag">Ad Groups</div>
              </div>
              <div className="table_block flex flex-col">
                {localData?.length ? (
                  <>
                    <div className={`global-row flex flex-col `}>
                      <div
                        className={`global-row-box flex items-center cursor-pointer`}
                      >
                        <div className="row-item table-name flex items-start justify-center flex-col">
                          <div className="tag-lbl">
                            Add Ad Elements to multiple Ad Groups
                          </div>
                        </div>
                        <div className="row-item flex items-start">
                          <div
                            className="item flex items-center mr-9"
                            onClick={(e) => setSelectedGlobalBox("headline")}
                          >
                            <button
                              className={`cleanbtn radio-btn rel ${
                                selectedGlobalBox === "headline" ? "on" : ""
                              }`}
                            />
                            <div className="toggle-desc ml-2">
                              {/* <div className="mr-2">{countHeadlines2(item)?.length}</div> */}
                              Headlines
                            </div>
                          </div>
                          <div
                            className="item flex items-center"
                            onClick={(e) => setSelectedGlobalBox("description")}
                          >
                            <button
                              className={`cleanbtn radio-btn rel ${
                                selectedGlobalBox === "description" ? "on" : ""
                              }`}
                            />
                            <div className="toggle-desc ml-2">
                              {/* <div className="mr-2">{countDescription2(item)?.length}</div> */}
                              Descriptions
                            </div>
                          </div>
                        </div>
                        <div className="row-item flex items-center justify-end">
                          <div className="icons-actions flex items-center">
                            <div
                              id="website-icon"
                              className="cloud-icon icon flex items-center justify-center relative mr-2"
                              onClick={(e) => {
                                setOpenGenerateUrl(true);
                                setModelData({ item: "", index: 92 });
                              }}
                            >
                              <CloudIcon />
                            </div>
                            <div
                              className="arrow-icon icon flex items-center justify-center"
                              onClick={(e) => {
                                setGlobalExpend(!globalExpend);
                              }}
                            >
                              {globalExpend ? (
                                <ArrowUpIcon />
                              ) : (
                                <ArrowDownIcon />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {globalExpend && (
                        <>
                          {selectedGlobalBox === "headline" ? (
                            <GlobalHeadline item={globalData.headlines} />
                          ) : selectedGlobalBox === "description" ? (
                            <GlobalDescription item={globalData.description} />
                          ) : null}
                        </>
                      )}
                    </div>
                    <div className={`main-table-column flex items-center`}>
                      <div
                        className={`tbl-column flex items-center cursor-pointer w-full`}
                      >
                        <div className="row-item flex items-start justify-center flex-col">
                          <div className="tag ">Campaign</div>
                        </div>
                        <div className="row-item flex items-start justify-center flex-col">
                          <div className="tag">Ad Group</div>
                        </div>
                        <div className="row-item flex items-start justify-center flex-col">
                          <div className="tag">
                            Total Headlines
                            <br />
                            Total Descriptions
                          </div>
                        </div>
                        <div className="row-item flex items-start justify-center flex-col">
                          <div className="tag">Action</div>
                        </div>
                      </div>
                    </div>
                    <>
                      {localData?.map((item, index) => (
                        <TableRow item={item} index={index} />
                      ))}
                    </>
                  </>
                ) : (
                  <>
                    <div className="block-tag flex items-center justify-center">
                      Data not found!
                    </div>
                  </>
                )}
              </div>
              <div className="tbl-sec-hdr flex items-center justify-center mt-5">
                {localData?.length ? (
                  <div className="dowload-btn flex items-center">
                    <CSVLink
                      data={mod_localData}
                      headers={headers}
                      filename={"RSAProDownloadFile.csv"}
                      asyncOnClick={true}
                      onClick={(event, done) => {
                        prepare_csv_data_to_download();
                        done();
                      }}
                    >
                      <div className="btn button">Download File</div>
                    </CSVLink>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <Modal open={open} onClose={() => setOpen(false)}>
          <TableRowModel setOpen={setOpen} modelData={modelData} />
        </Modal>

        <Modal open={openGenerateUrl} onClose={() => setOpenGenerateUrl(false)}>
          <GenerateUrlSummaryModel
            setOpenGenerateUrl={setOpenGenerateUrl}
            modelData={modelData}
          />
        </Modal>
      </div>
    </Wrapper>
  );
};

export default Main;
